import store from "@/store/index.js";

export default [
  {
    path: "/accountCenter",
    name: "accountCenter",
    meta: { requiresAuth: true },
    component: () => import("@/views/AccountCenter.vue"),
    children: [
      {
        path: "pass",
        name: "pass",
        meta: { requiresAuth: true },
        component: () => import("@/components/AccountCenter/Pass.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchPassUsers");
          next();
        }
      },
      {
        path: "applying",
        name: "applying",
        meta: { requiresAuth: true },
        component: () => import("@/components/AccountCenter/Applying.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchApplyingUsers");
          next();
        }
      },
      {
        path: "reject",
        name: "reject",
        meta: { requiresAuth: true },
        component: () => import("@/components/AccountCenter/Reject.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchBlackList");
          next();
        }
      },
      {
        path: "userDetail/:userId",
        name: "userDetail",
        meta: { requiresAuth: true },
        component: () => import("@/components/AccountCenter/UserDetail.vue")
      },
      {
        path: "accountsLog",
        name: "accountsLog",
        meta: { requiresAuth: true },
        component: () => import("@/components/AccountCenter/AccountsLog.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchAccountsLog");
          next();
        }
      }
    ]
  }
];
